import { GameState, DialogueHistoryEntry } from '../../types';

/**
 * 状态提示构建器，负责构建游戏状态部分
 */
export class StatePromptBuilder {
  /**
   * 构建游戏状态文本
   * @param state 游戏状态
   * @returns 构建好的游戏状态文本
   */
  buildGameState(state: GameState): string {
    return `当前游戏状态：
场景：${state.currentScene}
玩家物品：${state.inventory.join(', ') || '无'}
已触发的事件：${Object.entries(state.flags)
      .filter(([_, value]) => value)
      .map(([key, _]) => key)
      .join(', ') || '无'}
NPC关系：${Object.entries(state.relationships)
      .map(([npc, value]) => `${npc}: ${value}`)
      .join(', ') || '无'}`;
  }

  /**
   * 构建对话历史文本
   * @param history 对话历史
   * @returns 构建好的对话历史文本
   */
  buildDialogueHistory(history: DialogueHistoryEntry[]): string {
    if (history.length === 0) {
      return '';
    }

    // 只取最近的5条历史记录
    const recentHistory = history.slice(-200);
    // const recentHistory = history;
    
    
    return `最近的对话历史：\n${recentHistory
      .map(entry => {
        return `[${entry.scene}] 玩家: ${entry.player_choice}\n响应: ${entry.npc_response}`;
      })
      .join('\n\n')}`;
  }
} 